// assets
import {
    IconUsers,
    IconClipboardList,
    IconBarbell,
    IconCalendarUser,
    IconCalendarPlus,
    IconCalendarCheck,
    IconCalendarCancel,
    IconCalendarStats
} from '@tabler/icons-react';

// constant
const icons = {
    IconUsers,
    IconClipboardList,
    IconBarbell,
    IconCalendarUser,
    IconCalendarPlus,
    IconCalendarCheck,
    IconCalendarCancel,
    IconCalendarStats
};

// ==============================|| SERVICE MENU ITEMS ||============================== //

const examAdd = {
    id: 'examAdd',
    title: '검사 진행',
    type: 'group',
    children: [
        {
            id: 'exam-register',
            title: '검사 등록',
            type: 'item',
            url: '/service/exam/register',
            icon: IconCalendarPlus,
            breadcrumbs: true
        }
    ]
};

export default examAdd;
